import React from 'react';
import { DataTypeProvider } from '@devexpress/dx-react-grid';
import { Link } from '@material-ui/core';
import moment from 'moment';
import { isNumber } from 'util';

export const BlankFieldFormatter = props => (
  <DataTypeProvider
    formatterComponent={({ value }) => {
      const valueIfBlank = props.valueIfBlank || '--';
      return value ? value : valueIfBlank;
    }}
    {...props}
  />
);

export const CurrencyFormatter = props => (
  <DataTypeProvider
    formatterComponent={({ value }) => {
      const valueIfBlank = props.valueIfBlank || '0.00';
      if (value && isNumber(value)) return `$${value.toFixed(2)}`;
      return value ? value : valueIfBlank;
    }}
    {...props}
  />
);

export const DateFormatter = props => (
  <DataTypeProvider
    formatterComponent={({ value }) => {
      const valueIfBlank = props.valueIfBlank || '--';
      const format = props.format || 'MMM D, YYYY'; // TODO: Make the default date format a global constant
      return value ? moment(value).format(format) : valueIfBlank;
    }}
    {...props}
  />
);

export const LinkFieldFormatter = props => (
  <DataTypeProvider
    formatterComponent={args => {
      const { value } = args;
      const linkProps = { ...props };
      if (props.onClick && !props.href) {
        linkProps.component = 'button';
      }
      if (props.onClick) {
        linkProps.onClick = event => {
          props.onClick(args);
          event.stopPropagation();
        };
      }
      delete linkProps.for;

      // TODO: Add default className/classes
      const valueIfBlank = props.valueIfBlank || '--';
      return value ? <Link {...linkProps}>{value}</Link> : valueIfBlank;
    }}
    {...props}
  />
);
